// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-entry-description {
  position: relative;
}
.dialog-entry-description__subtitle {
  color: var(--g-color-text-secondary);
  margin-bottom: 21px;
}
.dialog-entry-description__length-counter {
  text-align: right;
  color: var(--g-color-text-secondary);
  margin-top: 6px;
}
.dialog-entry-description__length-counter_error {
  color: var(--g-color-text-danger);
}
.dialog-entry-description__content {
  margin-top: 6px;
  min-width: 656px;
  max-width: 736px;
}
.dialog-entry-description_mobile {
  padding: 0 var(--g-spacing-4);
}
.dialog-entry-description_mobile .dialog-entry-description__content {
  padding: var(--g-spacing-4) 0;
  margin-top: 0;
  min-width: 100%;
}
.dialog-entry-description__yfm-loader {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogEntryDescription/DialogEntryDescription.scss"],"names":[],"mappings":"AAAA;EAEI,kBAAA;AAAJ;AAEI;EACI,oCAAA;EACA,mBAAA;AAAR;AAGI;EACI,iBAAA;EACA,oCAAA;EACA,eAAA;AADR;AAGQ;EACI,iCAAA;AADZ;AAKI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAHR;AAMI;EACI,6BAAA;AAJR;AAMQ;EACI,6BAAA;EACA,aAAA;EACA,eAAA;AAJZ;AAQI;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANR","sourcesContent":[".dialog-entry-description {\n  position: relative;\n}\n.dialog-entry-description__subtitle {\n  color: var(--g-color-text-secondary);\n  margin-bottom: 21px;\n}\n.dialog-entry-description__length-counter {\n  text-align: right;\n  color: var(--g-color-text-secondary);\n  margin-top: 6px;\n}\n.dialog-entry-description__length-counter_error {\n  color: var(--g-color-text-danger);\n}\n.dialog-entry-description__content {\n  margin-top: 6px;\n  min-width: 656px;\n  max-width: 736px;\n}\n.dialog-entry-description_mobile {\n  padding: 0 var(--g-spacing-4);\n}\n.dialog-entry-description_mobile .dialog-entry-description__content {\n  padding: var(--g-spacing-4) 0;\n  margin-top: 0;\n  min-width: 100%;\n}\n.dialog-entry-description__yfm-loader {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
